import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { ComponentsModule } from '../shared/components/components.module';
import { MaterialModule } from '../shared/material.module';

import { DefaultLayoutComponent } from './default-layout';
import { MobileLayoutComponent } from './mobile-layout';

@NgModule({
  declarations: [DefaultLayoutComponent, MobileLayoutComponent],
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    ComponentsModule,
    TranslateModule.forChild(),
  ],
  exports: [DefaultLayoutComponent, MobileLayoutComponent],
})
export class LayoutsModule {}
